let revealStatus = "input"
let loading = false
let lastCode = false
let debugging = false

const revealError = document.querySelector(".widget--code-input .reveal-error")
const revealErrorText = document.querySelector(".widget--code-input .reveal-error .inner")
const revealInput = document.querySelector("#reveal-input")

const redirectFrame = document.querySelector("iframe.webpage-embed")

const landingPageElem = document.querySelector("#landing-page")

function showError(text) {
    if(text) {
        // Set error
        revealErrorText.innerText = text
        revealError.classList.add("show")
        revealError.style.height = revealErrorText.offsetHeight + "px"
    } else {
        // Unset error message
        revealError.classList.remove("show")
        revealError.style.height = "0px"
    }
    return false
}

// Handle form submit
document.querySelector(".widget--code-input form").addEventListener("submit", (e) => {
    e.preventDefault()
    tryCode()
    return false
})


async function tryCode() {

        // Prevent multiple submissions
        if(revealStatus != "input") return false;

        // Prevent input
        setAllowInput(false)

        // Reset statuses
        showError(false)
    
        // Validate input        
        if(revealInput.value.length < 6) {
            showError("Please enter a valid 6-character code.")
            setAllowInput(true)
            return false;
        }

        document.querySelector(".widget--code-input form").setAttribute('data-state', "loading")

        // Blur input to avoid bugs
        document.querySelectorAll(".widget--code-input form input").forEach((el) => el.blur())
    
        // Request code info from server and execute
        let allowInput = await loadCode(revealInput.value)

        // Allow input again
        setAllowInput(allowInput)

}

async function loadCode(code) {
    loading = true
    lastCode = code

    // Validate with server
    const result = await fetch("/api/reveal/?code=" + code).then((resp) => resp.json()).catch(() => false)

    loading = false

    try {
        // Validate server response
        if(!result || result.status === undefined || result.data === undefined) {
            showError("Couldn't validate code. Please try again.")
        } else {
            if(result.status == "DNE") {
                // Does Not Exist
                showError("Invalid code. Double check that it's correct.")
            } else if(result.status == "OK") {
                // Response OK
                // Landing page type handling
                if(result.data.type === "redirect") {
                    sendImpression(result.data.landing_id)
                    doCodeRedirect(result.data)
                    return false
                } else if(result.data.type === "landing_page") {
                    sendImpression(result.data.landing_id)
                    doCodeLandingPage(result.data)
                    return false
                } else {
                    throw(`Unsupported redirect type: ${result.data.type}`)
                }
            }
        }
    } catch(e) {
        // Critical failure :(
        console.error(e)
        showError("Something went wrong. Please try again.")
    }

    return true
}

function setAllowInput(allow = true) {
    if(allow) {
        document.querySelector(".widget--code-input form").removeAttribute('data-state')
        revealInput.removeAttribute("disabled")
        revealStatus = "input"
        revealInput.focus()
    } else {
        revealStatus = "validating"
        revealInput.blur()
        revealInput.setAttribute("disabled", "disabled")
    }
}

function doRevealCountdown() {
    console.log("REVLEA")
    document.querySelector(".widget--code-input form").setAttribute('data-state', "redirect")
    revealStatus = "loading"

    let countdownInverval = setInterval(() => {
        const time = document.querySelector(".widget--code-input form .time")
        if(time.innerText - 1 >= 0) {
            time.innerText = time.innerText - 1
        } else {
            clearInterval(countdownInverval)
        }
    }, 1200)
}
window.doRevealCountdown = doRevealCountdown

function doCodeRedirect(redirect) {
        // Load landing page
        redirectFrame.classList.add("show")
        redirectFrame.setAttribute("src", redirect.url)
    
        // Start countdown
        doRevealCountdown()
        setTimeout(() => {
            document.querySelector("#page").setAttribute('data-reveal', "slideUp")
        }, 3600)
}

function doCodeLandingPage(data) {
        // Load landing page
        landingPageElem.classList.add("show")
        console.log(data)
        window.landingPage.id = data?.landing_id
        window.loadLandingPage(landingPageElem, data.layout, "live", data.style)
    
        // Start countdown
        doRevealCountdown()
        setTimeout(() => {
            document.querySelector("#page").setAttribute('data-reveal', "slideUp")
            if(!debugging) {
                debugging = true
                //setInterval(() => { if(!loading) loadCode(lastCode) }, 3000)
            }
        }, 3600)
}

let impressionBusy = false
function sendImpression(id, ts = 0) {
    // Stop if busy
    if(impressionBusy) return false;
    impressionBusy = true;

    // Set data
    let formData = new FormData();
    formData.append("id", id || false)
    formData.append("ts", ts)

    fetch("/api/impression/", {
        method: "POST",
        body: formData
    }).then(res => {
        impressionBusy = false;
        res.json().then(json => {
            
            // Do follow-up impression tracking
            if(json && window.landingPage && !window.landingPage.trackingID) {
                window.landingPage.trackingID = json.ts
                setInterval(() => {
                    sendImpression(id, window.landingPage.trackingID)
                }, 3000)
            }

        })
    })

}